module.exports = __webpack_public_path__ + "img/delete-hover.8a477538.svg";